// extracted by mini-css-extract-plugin
export default {"Loading":"preloader_Loading__y28BT","circle":"preloader_circle__XAy8d","spinner-border":"preloader_spinner-border__scglJ","spin":"preloader_spin__6EOSi"};